// 1) utils/meiSeed.ts
export async function runMeiSeedingOnce(): Promise<boolean> {
  try {
    if (localStorage.getItem('meiSeeded') === 'true') return true;
    if (document.hidden) return false; // yêu cầu tab active

    const AC = window.AudioContext || (window as any).webkitAudioContext;
    const ctx: AudioContext = new AC();

    // resume trong gesture
    if (ctx.state === 'suspended') {
      await ctx.resume();
    }

    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    // volume rất nhỏ nhưng > 0
    gain.gain.value = 0.005; // bạn có thể thử 0.005

    // tần số “êm” và khó nghe thấy
    osc.type = 'sine';
    osc.frequency.value = 220; // hoặc 220 Hz càng khó nhận ra ở volume nhỏ

    osc.connect(gain);
    gain.connect(ctx.destination);

    const now = ctx.currentTime;
    osc.start(now);
    osc.stop(now + 10); // >= 7s để đáp ứng MEI

    await new Promise<void>((resolve) => {
      osc.onended = () => {
        try {
          osc.disconnect();
          gain.disconnect();
        } catch {}
        resolve();
      };
    });

    // Không cần giữ ctx mở nếu app bạn không dùng WebAudio
    try { await ctx.close(); } catch {}

    localStorage.setItem('meiSeeded', 'true');
    return true;
  } catch (e) {
    console.error('MEI seeding failed', e);
    return false;
  }
}
